import { BillListStatus } from "@boo/shared";

export const BILL_LIST_STATUS: Record<
  BillListStatus,
  { label: string; className: string }
> = {
  [BillListStatus.NeedsResolve]: {
    label: "Waiting resolve",
    className: "bg-red-500/10 text-red-500",
  },
  [BillListStatus.Ready]: {
    label: "Ready to finalize",
    className: "bg-primary/10 text-primary",
  },
  [BillListStatus.Reviewing]: {
    label: "Waiting review",
    className: "bg-muted text-muted-foreground",
  },
  [BillListStatus.NeedsConfirm]: {
    label: "Waiting confirm",
    className: "bg-red-500/10 text-red-500",
  },
  [BillListStatus.Waiting]: {
    label: "Waiting payment",
    className: "bg-muted text-muted-foreground",
  },
  [BillListStatus.Paid]: {
    label: "Paid all",
    className: "bg-emerald-500/10 text-emerald-500",
  },
};
